import { render, staticRenderFns } from "./AddBalance.vue?vue&type=template&id=28313de9&scoped=true&"
import script from "./AddBalance.vue?vue&type=script&lang=js&"
export * from "./AddBalance.vue?vue&type=script&lang=js&"
import style0 from "./AddBalance.vue?vue&type=style&index=0&id=28313de9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28313de9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VDialog,VIcon,VSlideXTransition})
